import $ from 'jquery';
import $hub from '@/core/hub';



const options = {
    selector: {
        trigger: '.js-onboarding-trigger'
    },
    attribute: {
        boardID: 'data-board-id'
    },
    event: {
        init: 'init.onboarding.app'
    }
};

const init = () => {
    // intercept click
    $(options.selector.trigger).on('click', function(event) {
        const boardID = (event.target.attributes[options.attribute.boardID] || {}).value;
        if (!boardID) throw new SyntaxError('data-board-id is required on the clicked element');

        // emit jquery event
        $hub.trigger(options.event.init, { event, data: boardID });
    });
};

export default { init };
